'use client';

import { PropsWithChildren, useMemo } from 'react';

import { useAuth } from '@/entities/user';
import { UserRole } from '@/shared/api';

interface ProtectedRoleComponentProps extends PropsWithChildren {
	allowedRoles: Array<UserRole | `${UserRole}`>;
	fallback?: React.ReactNode;
	loadingFallback?: React.ReactNode;
}

export const ProtectedRoleComponent = ({
	children,
	allowedRoles,
	fallback = null,
	loadingFallback = null,
}: ProtectedRoleComponentProps) => {
	const { user, loading } = useAuth();

	const isAllowed = useMemo(() => {
		if (allowedRoles.length === 0) {
			return true;
		}

		if (!user) {
			return false;
		}

		return allowedRoles.includes(user.role);
	}, [user, allowedRoles]);

	if (loading) {
		return <>{loadingFallback}</>;
	}

	if (isAllowed) {
		return <>{children}</>;
	}

	return <>{fallback}</>;
};
